import React from 'react';
import ContactUs from '../cancel/ContactUs';
import { useTeamModal } from '../../../hooks/subscriptions/useTeamModal';
import AccountPageConstants from 'constants/AccountPageConstants';

/**
 * Help page in the pause/cancel flow - shown when user needs assistance
 */
const BillingModalPauseHelp = () => {
  const { navigateToPage } = useTeamModal();

  const handleNext = () => {
    // After help, proceed to cancellation confirmation
    navigateToPage(AccountPageConstants.PAUSE_FEEDBACK_CONFIRM);
  };

  return (
    <ContactUs onNext={handleNext} />
  );
};

export default BillingModalPauseHelp;